document.addEventListener('DOMContentLoaded', function () {
 
  function scienceLinks() {
    console.log('science links') 

    //get url params string
    const urlParams = window.location.search.substring(1);
    

    console.log(urlParams)

    if(urlParams == "longevity") { 

      //scroll to .info-tab-wrap
      const yOffset = -0; // Negative value to scroll higher
      const y = document.querySelector('.info-tab-wrap').getBoundingClientRect().top + window.scrollY + yOffset;
      document.querySelector('.info-tab-wrap').classList.add('active'); 
      document.querySelector('.info-tab-wrap .button').innerHTML = 'Read Less';
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    if(urlParams == "nootropics") { 

      //scroll to .info-tab-wrap
      const yOffset = -0; // Negative value to scroll higher
      const y = document.querySelectorAll('.info-tab-wrap')[1].getBoundingClientRect().top + window.scrollY + yOffset;
      document.querySelectorAll('.info-tab-wrap')[1].classList.add('active'); 
      document.querySelectorAll('.info-tab-wrap')[1].querySelector('.button').innerHTML = 'Read Less';
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

  }

  function handleBlogPagination() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const pageParam = urlSearchParams.get('page');
    
    // Check if we're on a blog page with pagination (any page parameter)
    if (pageParam) {
      const blogPostsElement = document.getElementById('blog-posts');
      
      if (blogPostsElement) {
        // Add a small delay to ensure the page is fully loaded
        setTimeout(() => {
          const yOffset = -50; // Adjust this value to control the scroll position offset
          const y = blogPostsElement.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      } else {
        // Fallback: try to find blog posts container with different selector
        const fallbackElement = document.querySelector('[id*="blog-posts"]');
        if (fallbackElement) {
          setTimeout(() => {
            const yOffset = -50;
            const y = fallbackElement.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }, 100);
        }
      }
    }
  }
 
  // === Global initialisation ===
scienceLinks();
handleBlogPagination();
initializeSwipers();
initCountUp();
animatePaths();
graphToggle();
expandable();
unmute();
bundles();
faqTab();
initMobileBlogPosts();
 
  // Function to initialize Swiper
  function initializeSwiper(section) { 
    const slidesMobile = parseFloat(section.getAttribute('data-slides-mobile'), 10) || 2;
    const slidesDesktop = parseFloat(section.getAttribute('data-slides-desktop'), 10) || 4;
    const spaceBetweenMobile = parseFloat(section.getAttribute('data-space-between-mobile'), 10) || 2;
    const spaceBetweenDesktop = parseFloat(section.getAttribute('data-space-between-desktop'), 10) || 2;
    const loop = section.getAttribute('data-loop') === 'true' || false;

    const experts = section.getAttribute('data-experts') === 'true';
    const autoplay = section.getAttribute('data-auto-scroll') === 'true';
    const expandable = section.getAttribute('data-expandable') === 'true';



    const nextBtn = section.querySelector('.swiper-button-next'); 
    const prevBtn = section.querySelector('.swiper-button-prev');



    const swiperInstance = new Swiper(section, {
        autoHeight: false,
        slidesPerView: slidesDesktop,
        spaceBetween: spaceBetweenDesktop,
        // simulateTouch: true,
        mousewheel: {
            forceToAxis: true, // Swipes only in the axis of movement
            sensitivity: 1, // Adjust for finer or coarser control
        },
        // slidesOffsetAfter: 330.665,
        autoplay: autoplay ? { 
            delay: 50, // Continuous scrolling (no delay between slides)

            // pauseOnMouseEnter: true
        } : false,
        speed: autoplay ? 4650 : 500, // Adjust scrolling speed for smoothness
        // freeMode: true, // Enable free mode for smooth scrolling
        loop: loop ? true : false, // Enable loop mode
        breakpoints: {
            320: {
                slidesPerView: slidesMobile,
                spaceBetween: spaceBetweenMobile,
            },
            1040: {
                slidesPerView: slidesDesktop,
                spaceBetween: spaceBetweenDesktop,
            }
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        pagination: {
            el: section.querySelector('.swiper-pagination'),
            type: 'progressbar', // Enables the progress bar
        },
    });



    

    if (autoplay) {
      let paused = false; // Track whether autoplay is paused manually
      let currentTranslate = 0; // Store the exact current position
    
      section.addEventListener('mouseenter', () => {
        if (paused) return; // Prevent multiple triggers
        paused = true;
    
        // Get the real-time transform value
        const matrix = window.getComputedStyle(swiperInstance.wrapperEl).transform;
        currentTranslate = matrix !== 'none' ? parseFloat(matrix.split(',')[4]) : 0;
    
        swiperInstance.autoplay.stop(); // Stop autoplay
        swiperInstance.wrapperEl.style.transition = 'none'; // Disable ongoing transitions
        swiperInstance.setTranslate(currentTranslate); // Freeze slider at exact position
    

      });
    
      section.addEventListener('mouseleave', () => {
        if (!paused) return; // Prevent multiple triggers
        paused = false;

        setTimeout(() => {
          swiperInstance.autoplay.start(); // Ensure autoplay restarts

        }, 150);
      });
    }

    if (expandable) {
  setTimeout(setexpandables, 0);
}

    // Event Listener for slide change

    if(experts) {
      const cards = document.querySelectorAll('.experts__media');
      const inner = document.querySelector('.expandable__inner');
  
      cards.forEach((btn, i) => {
        const video = btn.querySelector('video');
        if(i != 0){

          if(video) {
    
            setTimeout(() => {
              video.pause();
            }, 5000);      
    
            //remove autoplay
    
          }
        }
      });


      swiperInstance.on('slideChange', () => {

        cards.forEach((btn) => {
          const video = btn.querySelector('video');      
    

          if(video) {           
            video.pause();   
          }
        });

    
        const activeIndex = swiperInstance.activeIndex; // Get the active slide index
        const realIndex = swiperInstance.realIndex; // Get the real index (ignoring duplicated slides in a loop)

        // Perform action on the active slide

        setTimeout(() => {
          const activeSlide = section.querySelector('.swiper-slide-active');  
          const video = activeSlide.querySelector('.slider-item-media-element');  
  
          if(video) {

            video.play();
          }
        }, 100);  


 
        // activeSlide.style.backgroundColor = 'lightblue'; // Example: Change background color
      });
    }
    

    return swiperInstance;
  }

  function setexpandables() {

    //if window width above 1200
    if(window.innerWidth > 1200) {


    setTimeout(() => {

      const cards = document.querySelectorAll('.expandable__inner .expandable__card');

      //get window width
      const windowWidth = window.innerWidth;

      console.log(cards[1])

      let standardWidth = 0

      if(cards[1].classList.contains('active')) {
        standardWidth = parseFloat(window.getComputedStyle(cards[0]).width);
      }else{
        standardWidth = parseFloat(window.getComputedStyle(cards[1]).width);
      }


      
      const expandedWidth = standardWidth * 2;
      const paddingTop = standardWidth;

      console.log(standardWidth, "standardWidth");
      console.log(expandedWidth, "expandedWidth");
      
      // Ensure CSS variable is correctly set with 'px'
      document.documentElement.style.setProperty('--expanded-width', `${expandedWidth - 10}px`);
      document.documentElement.style.setProperty('--padding-top', `${paddingTop}px`);

      cards.forEach((btn, i) => {
        console.log(btn.style.width);
      })
      
    }, 750);
  }

  }


function initializeSwipers() {
  const sections = document.querySelectorAll('.swiper-container');

  sections.forEach(section => {
    // Destroy existing Swiper safely
    if (section.swiper) {
      section.swiper.destroy(true, true);
    }

    // Initialise fresh
    initializeSwiper(section);

    section.style.opacity = 1;
  });
}

  // Helper function to animate the count-up
  function countUp(element, target) {
    let start = 0;
    const duration = 2000; 
    const steps = 100;
    const stepTime = duration / steps;
    const increment = target / steps;

    const hasDecimals = target % 1 !== 0;
    const decimalPlaces = hasDecimals ? 2 : 0;

    element.style.overflow = "visible";
    element.style.width = "auto";

    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target; // cap to avoid rounding overshoot
        clearInterval(interval);
      }
      element.textContent = start.toFixed(decimalPlaces);
    }, stepTime);
  }

  // Function to lock the width of the elements
  function lockWidth(element) {
    const computedStyle = window.getComputedStyle(element);
    const width = computedStyle.width;
    element.style.width = width; // Set the width explicitly
    element.style.overflow = "hidden"; // Ensure no overflow during animation
  }

  // Function to observe elements and trigger the animation
  function initCountUp() {
    const elements = document.querySelectorAll('.js-count-up');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            const targetNumber = parseFloat(element.textContent);

            element.style.overflow = "visible";
            countUp(element, targetNumber);

            observer.unobserve(element); // Stop observing once the animation runs
          }
        });
      },
      {
        threshold: 0.5 // Trigger when 50% of the element is visible
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  function animatePaths() {
    const paths = document.querySelectorAll(".draw");
  
    paths.forEach((path) => {
      const pathLength = path.getTotalLength(); // Get the length of the path
      path.style.strokeDasharray = pathLength; // Set dasharray to the path length
      path.style.strokeDashoffset = pathLength; // Initially hide the path
      path.classList.add("animate"); // Add the class to prepare for animation
  
      // Intersection Observer to animate only when the path is in view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            console.log(entry)
            if (entry.isIntersecting) {
              path.classList.add("active"); // Trigger the animation
              observer.unobserve(path); // Stop observing once animated
            }
          });
        },
        { threshold: 0.1 } // Trigger when 10% of the path is visible
      );
  
      observer.observe(path);
    });
  }

  function graphToggle() {
    const toggleBtns = document.querySelectorAll('.graph__toggle-btn');
    const graphs = document.querySelectorAll('.graph__animation');
    const content = document.querySelectorAll('.graph__content-wrap');
    const images = document.querySelectorAll('.graph-image');  



    toggleBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {

        const blockId = e.target.getAttribute('data-block-id'); 



        toggleBtns.forEach((btn) => {
          btn.classList.remove('active');
        });

        content.forEach((item) => {
          item.classList.remove('active');

          if(item.getAttribute('data-block-id') === blockId) {
            item.classList.add('active');
          }
        });

        graphs.forEach((graph) => {
          graph.classList.remove('active');

          if(graph.getAttribute('data-block-id') === blockId) {
            graph.classList.add('active');
          }
        });

        images.forEach((image) => {
          image.classList.remove('active');

          if(image.getAttribute('data-block-id') === blockId) {
            image.classList.add('active');
          }
        });

       

        btn.classList.toggle('active');


      });
    });

  }

  function bundles(){

    const quickAddBtns = document.querySelectorAll('product-bundler .add-to-cart');

    quickAddBtns.forEach((btn) => {
      btn.click();
    });
  }


  function expandable() {
    const expandableSections = document.querySelectorAll('.expandable__inner');
  
    if (expandableSections.length === 0) return;
  
    expandableSections.forEach((inner) => {
      const expandableBtns = inner.querySelectorAll('.expandable__card');
      if (expandableBtns.length === 0) return;
  
      let currentIndex = Array.from(expandableBtns).findIndex(btn => btn.classList.contains('active'));
      if (currentIndex === -1) currentIndex = 0; // Default to first card if none active
      let autoRotateInterval;
  
      function setActiveCard(index) {
        expandableBtns.forEach((btn, i) => {
          if (i === index) {
            btn.classList.add('active');
            const video = btn.querySelector('video');
            if (video) video.play();
          } else {
            btn.classList.remove('active');
            const video = btn.querySelector('video');
            if (video) video.pause();
          }
        });
      }
  
      function startAutoRotate() {
        stopAutoRotate(); // Ensure any previous interval is cleared
        autoRotateInterval = setInterval(() => {
          currentIndex = (currentIndex + 1) % expandableBtns.length;
          setActiveCard(currentIndex);
        }, 7000);
      }
  
      function stopAutoRotate() {
        clearInterval(autoRotateInterval);
      }
  
      expandableBtns.forEach((btn, index) => {
        btn.addEventListener('click', function () {
          stopAutoRotate();
          setActiveCard(index);
          currentIndex = (index ) % expandableBtns.length;
          startAutoRotate();
        });
  
        btn.addEventListener('mouseenter', stopAutoRotate);
        btn.addEventListener('mouseleave', startAutoRotate);
      });
  
      startAutoRotate();
    });
  }
  


  function unmute() {

    const muteToggles = document.querySelectorAll('.mute-toggle');

    muteToggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {

        // lok for nereast video up
        const video = btn.parentElement.parentElement.querySelector('video');

        if(video) {
          if(video.muted) {
            video.muted = false;
            btn.parentElement.classList.remove('muted');

          } else {
            video.muted = true;
            btn.parentElement.classList.add('muted');

          }
        }

      });
    });

  }


  console.log('loaded')

  function faqTab() {
    const tabButtons = document.querySelectorAll('.info-tab-wrap .button');

    const tabsT = document.querySelectorAll('.info-tab__right .info-tabs__tab');

    tabsT.forEach(tab => {
      
      tab.addEventListener('click', () => {
        console.log(tab)

          if(tab.classList.contains('active')) {
       
          }
          else {
            // tab.classList.remove('active');

            // tab.querySelector('.info-tabs__tab-caption').style.display = 'none';
            // tab.classList.add('active');
          }
  
  

          console.log('else') 
  
          setTimeout(()=>{
            
            // const yOffset = -200; // Negative value to scroll higher
            // const y = tab.getBoundingClientRect().top + window.scrollY + yOffset;
            
            // window.scrollTo({ top: y, behavior: 'smooth' });    
          }, 150);   
  
      });
    });

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const wrap = btn.closest('.info-tab-wrap');

        if(wrap.classList.contains('active')) {
          wrap.classList.remove('active');
          btn.innerHTML = 'Read More';  
        }
        else {
          wrap.classList.add('active');
          btn.innerHTML = 'Read Less';
        }
      });

    });
  }


  async function waitForElement(selector, root = document, interval = 100, timeout = 5000) {
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      const checkExist = setInterval(() => {
        const element = root.querySelector(selector);
        if (element) {
          clearInterval(checkExist);
          resolve(element);
        }
        if (Date.now() - startTime > timeout) {
          clearInterval(checkExist);
          reject(new Error("Element not found within timeout."));
        }
      }, interval);
    });
  }
  
  
  
  // Handle browser back/forward navigation
  window.addEventListener('popstate', function() {
    handleBlogPagination();
  });
  
  

  document.querySelectorAll(".info-tabs__tab").forEach(tab => {
    tab.innerHTML = tab.innerHTML.replace(/\[(\d{2})\]/g, '<span class="sup">[$1]</span>');
  });


  //on resize
  window.addEventListener('resize', function() {
    setexpandables()
  });



  


  

  // Shopify Customizer Event Listener for Switching Layouts
  document.addEventListener('shopify:section:load', function() {
    initializeSwipers();
    initCountUp()
    animatePaths()
    graphToggle()
    expandable()
    setexpandables()
    handleBlogPagination()
    

  });

  function initMobileBlogPosts() {
    const blogPosts = document.querySelectorAll('.media-posts .expandable__card');
  
    if (window.innerWidth < 768) {
      blogPosts.forEach(post => {
        let startX, startY;
        let moved = false;
  
        post.addEventListener('touchstart', (e) => {
          const touch = e.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          moved = false;
        });
  
        post.addEventListener('touchmove', (e) => {
          const touch = e.touches[0];
          const deltaX = Math.abs(touch.clientX - startX);
          const deltaY = Math.abs(touch.clientY - startY);
          if (deltaX > 10 || deltaY > 10) {
            moved = true;
          }
        });
  
        post.addEventListener('touchend', (e) => {
          if (!moved) {
            const link = post.querySelector('.js-blog-click');
            if (link) window.location.href = link.href;
          }
        });
  
        // Optional: Add mouse fallback for desktop or testing in browser
        let mouseDownX, mouseDownY;
        post.addEventListener('mousedown', (e) => {
          mouseDownX = e.clientX;
          mouseDownY = e.clientY;
          moved = false;
        });
  
        post.addEventListener('mousemove', (e) => {
          if (Math.abs(e.clientX - mouseDownX) > 5 || Math.abs(e.clientY - mouseDownY) > 5) {
            moved = true;
          }
        });
  
        post.addEventListener('mouseup', (e) => {
          if (!moved) {
            const link = post.querySelector('.js-blog-click');
            if (link) window.location.href = link.href;
          }
        });
      });
    }
  }
  

  document.addEventListener('shopify:block:select', function() {
    initializeSwipers();
    initCountUp()
    animatePaths()
    graphToggle()
    expandable()
    setexpandables()
    initMobileBlogPosts()
    handleBlogPagination()
    
  });


  
});

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".bundle-value-line");
  if (!el) return;

  const price = Number(el.dataset.bundlePrice || 0);
  const compare = Number(el.dataset.bundleCompare || 0);


  if (!compare || compare <= price) return;

  const saved = compare - price;

const formatMoney = (cents) => {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }

  // Fallback
  return (cents / 100).toFixed(2);
};

  el.textContent = `Original value: ${formatMoney(compare)} · You save ${formatMoney(saved)} today`;
});




